import { GridColumn } from "@progress/kendo-react-grid";
import { SortDescriptor } from "@progress/kendo-data-query";
import { protectedResources } from '../../authConfig';
import { BaseGrid } from '../../components/KendoGrid/BaseGrid';
import { NoCommaNumericFilterCell } from "../../components/KendoGrid/NumericFilterCell";
import { GuidFilterCell } from "../../components/KendoGrid/StringFilterCell";
import { AuditActionFilterCell } from "../../components/KendoGrid/AuditActionFilterCell";
import { DateRangeFilter } from "../../components/KendoGrid/DateRangeFilter";

const LabAuditList = () => {
    const recentEntriesFirstSort = [{
        field: "AuditDate",
        dir: "desc"
    } as SortDescriptor];

    return (
        <BaseGrid verb={'POST'} pageTitle='Lab List' endpoint={protectedResources.audit.apiLab.endpoint + "KendoGridRead"} intialSort={recentEntriesFirstSort} key={Date.now()}>
            <GridColumn width="240px" field='auditDate' title='Audit Date' filter="date" filterCell={DateRangeFilter} />
            <GridColumn width="140px" field='auditAction' title='Action' filterCell={AuditActionFilterCell} />
            <GridColumn width="200px" field='modifiedByName' title='Modified By Name' />

            <GridColumn width="100px" field='id' title='ID' filterCell={NoCommaNumericFilterCell} filter="numeric" />
            <GridColumn width="200px" field='facilityName' title='Facility Name' />
            <GridColumn width="200px" field='addressLine1' title='Address Line 1' />
            <GridColumn width="200px" field='addressLine2' title='Address Line 2' />
            <GridColumn width="200px" field='city' title='City' />
            <GridColumn width="100px" field='state' title='State' />
            <GridColumn width="100px" field='country' title='Country' />
            <GridColumn width="125px" field='postalCode' title='Postal Code' />
            <GridColumn width="175px" field='labPhoneNumber' title='Lab Phone Number' />
            <GridColumn width="100px" field='labPhoneNumberExtension' title='Extension' />
            <GridColumn width="200px" field='primaryContactName' title='Primary Contact Name' />
            <GridColumn width="200px" field='sendNotificationsTo' title='Send Notifications To' />
             
            <GridColumn width="340px" field='createdBy' title='Created By' filterCell={GuidFilterCell} />
            <GridColumn width="200px" field='createdByName' title='Created By Name' />
            <GridColumn width="240px" field='createdOn' title='Created On' filter="date" filterCell={DateRangeFilter} />
            <GridColumn width="340px" field='modifiedBy' title='Modified By' filterCell={GuidFilterCell} />
            <GridColumn width="240px" field='modifiedOn' title='Modified On' filter="date" filterCell={DateRangeFilter} />
            <GridColumn width="750px" field='auditUser' title='Audit User' />
        </BaseGrid>
    );
}

export default LabAuditList;